
/* BRANCH */
export const GET_BRANCH_LISTING = "GET_BRANCH_LISTING";
export const GET_BRANCH_LISTING_SUCCESS = "GET_BRANCH_LISTING_SUCCESS";
export const GET_BRANCH_LISTING_FAIL = "GET_BRANCH_LISTING_FAIL";

export const CREATE_BRANCH = "CREATE_BRANCH";
export const CREATE_BRANCH_SUCCESS = "CREATE_BRANCH_SUCCESS";
export const CREATE_BRANCH_FAIL = "CREATE_BRANCH_FAIL";

export const UPDATE_BRANCH = "UPDATE_BRANCH";
export const UPDATE_BRANCH_SUCCESS = "UPDATE_BRANCH_SUCCESS";
export const UPDATE_BRANCH_FAIL = "UPDATE_BRANCH_FAIL";

export const DELETE_BRANCH = "DELETE_BRANCH";
export const DELETE_BRANCH_SUCCESS = "DELETE_BRANCH_SUCCESS";
export const DELETE_BRANCH_FAIL = "DELETE_BRANCH_FAIL";

export const RESET_BRANCH_STATE = 'RESET_BRANCH_STATE';
export const RESET_BRANCH_ACTION_STATE = 'RESET_BRANCH_ACTION_STATE';